import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { ProductListComponent } from './components/product-list/product-list.component';
import { ExpansionPanelsComponent } from './components/expansion-panels/expansion-panels.component';
import { RenderMarkdownComponent } from './components/markdown/render-markdown.component';
import { ToastComponent } from './components/toast/toast.component';
import { ErrorBannerComponent } from './components/error-banner/error-banner.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { TooltipInfoComponent } from './components/tooltip-info/tooltip-info.component';
import { MarkdownModule } from 'ngx-markdown';
import { OpenNativePickerOnClickDirective } from './directives/open-native-picker-on-click.directive';
import { SystemToastComponent } from './components/system-toast/system-toast.component';
import { SearchableSelectComponent } from './components/searchable-select/searchable-select.component';
import { StatusBadgeComponent } from './components/status-badge/status-badge.component';
import { CertificationActionButtonComponent } from './components/certification-action-button/certification-action-button.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { NewCertificateErrorBannerComponent } from './components/new-certificate-error-banner/new-certificate-error-banner.component';

const components = [
  HeaderComponent,
  FooterComponent,
  ProductListComponent,
  PageNotFoundComponent,
  ExpansionPanelsComponent,
  RenderMarkdownComponent,
  ToastComponent,
  SystemToastComponent,
  ErrorBannerComponent,
  TooltipComponent,
  TooltipInfoComponent,
  SearchableSelectComponent,
  StatusBadgeComponent,
  CertificationActionButtonComponent,
  ConfirmationDialogComponent,
  NewCertificateErrorBannerComponent
];

const directives = [
  OpenNativePickerOnClickDirective
];

@NgModule({
  declarations: [...components, ...directives],
  imports: [
    CommonModule,
    RouterModule,
    MarkdownModule.forChild()
  ],
  exports: [...components, ...directives],
})
export class SharedModule {}
